export var Orientation;
(function (Orientation) {
    Orientation["VERTICAL"] = "vertical";
    Orientation["HORIZONTAL"] = "horizontal";
})(Orientation || (Orientation = {}));
